export const environment = {
  production: true,
  instantHost: 'https://instant.skideo.com/',
  createHost: 'https://create.skideo.com/',
};
